import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import classNames from 'classnames';
import Tooltip from '../tooltip/tooltip';
var DockingPlaneButton = /*#__PURE__*/function (_React$Component) {
  function DockingPlaneButton() {
    var _this;
    _classCallCheck(this, DockingPlaneButton);
    _this = _callSuper(this, DockingPlaneButton);
    _this.hidePopoverTimeout = undefined;
    _this.state = {
      showPopover: false,
      hoverPopover: false
    };
    return _this;
  }
  _inherits(DockingPlaneButton, _React$Component);
  return _createClass(DockingPlaneButton, [{
    key: "showPopover",
    value: function showPopover() {
      var _this2 = this;
      if (!this.isDisabled()) {
        this.setState({
          showPopover: true
        });
        window.setTimeout(function () {
          _this2.setState({
            hoverPopover: true
          });
        });
        if (this.hidePopoverTimeout) {
          window.clearTimeout(this.hidePopoverTimeout);
        }
      }
    }
  }, {
    key: "onChange",
    value: function onChange(direction) {
      if (!this.isDisabled() && !this.props.disabledDirections.includes(direction)) {
        this.props.onChange(direction);
      }
    }
  }, {
    key: "hidePopover",
    value: function hidePopover() {
      var _this3 = this;
      this.setState({
        hoverPopover: false
      });
      this.hidePopoverTimeout = window.setTimeout(function () {
        _this3.setState({
          showPopover: false
        });
        _this3.hidePopoverTimeout = undefined;
      }, 200);
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.props.disabled === true || this.isVerticalDisabled() && this.isHorizontalDisabled();
    }
  }, {
    key: "isVerticalDisabled",
    value: function isVerticalDisabled() {
      return this.props.disabledDirections.includes('VERTICAL');
    }
  }, {
    key: "isHorizontalDisabled",
    value: function isHorizontalDisabled() {
      return this.props.disabledDirections.includes('HORIZONTAL');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.hidePopoverTimeout) {
        window.clearTimeout(this.hidePopoverTimeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(this.props.getClassName('control-docking-plane-button-outer'), {
          'is-disabled': this.isDisabled()
        }),
        "data-hook": this.props.dataHook
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('control-docking-plane-button', {
          'plane-docked': this.props.vertical || this.props.horizontal,
          'is-disabled': this.isDisabled()
        }),
        onClick: function onClick() {
          return _this4.showPopover();
        }
      }, /*#__PURE__*/React.createElement(Tooltip, {
        content: this.props.centerHint,
        disabled: !this.props.centerHint,
        isHint: true,
        alignment: "TOP"
      }, /*#__PURE__*/React.createElement("div", {
        className: "docking-point"
      }))), /*#__PURE__*/React.createElement("div", {
        className: classNames('control-docking-plane-popover', {
          shown: this.state.showPopover,
          hover: this.state.hoverPopover
        }),
        onMouseEnter: function onMouseEnter() {
          return _this4.showPopover();
        },
        onMouseLeave: function onMouseLeave() {
          return _this4.hidePopover();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "docking-plane-spacer"
      }), /*#__PURE__*/React.createElement("div", {
        "data-direction": "vertical",
        className: classNames('docking-plane vertical', {
          'plane-docked': this.props.vertical,
          'is-disabled': this.isVerticalDisabled()
        }),
        onClick: function onClick() {
          return _this4.onChange('VERTICAL');
        }
      }, /*#__PURE__*/React.createElement(Tooltip, {
        dataHook: "vertical-tooltip",
        content: this.props.translateIfNeeded(this.props.hintVertical),
        disabled: !this.props.translateIfNeeded(this.props.hintVertical),
        isHint: true,
        alignment: "TOP"
      }, /*#__PURE__*/React.createElement("div", {
        "data-hook": "vertical-plane",
        className: "docking-point"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "docking-plane-spacer"
      }), /*#__PURE__*/React.createElement("div", {
        "data-direction": "horizontal",
        className: classNames('docking-plane horizontal', {
          'plane-docked': this.props.horizontal,
          'is-disabled': this.isHorizontalDisabled()
        }),
        onClick: function onClick() {
          return _this4.onChange('HORIZONTAL');
        }
      }, /*#__PURE__*/React.createElement(Tooltip, {
        dataHook: "horizontal-tooltip",
        content: this.props.translateIfNeeded(this.props.hintHorizontal),
        disabled: !this.props.translateIfNeeded(this.props.hintHorizontal),
        isHint: true,
        alignment: "TOP"
      }, /*#__PURE__*/React.createElement("div", {
        "data-hook": "horizontal-plane",
        className: "docking-point"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "docking-plane-spacer"
      })));
    }
  }]);
}(React.Component);
DockingPlaneButton.displayName = displayNames.DOCKING_PLANE_BUTTON;
DockingPlaneButton.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  vertical: PropTypes.bool,
  horizontal: PropTypes.bool,
  hintVertical: PropTypes.string,
  hintHorizontal: PropTypes.string,
  disabled: PropTypes.string,
  disabledDirections: PropTypes.arrayOf(PropTypes.string)
};
DockingPlaneButton.defaultProps = {
  vertical: false,
  horizontal: false,
  hintVertical: 'Vertical',
  hintHorizontal: 'Horizontal',
  disabled: false,
  disabledDirections: []
};
export default compose(DockingPlaneButton);